export const FETCH_INCENTIVE_UPDATE_REASONS_REQUESTED = 'FETCH_INCENTIVE_UPDATE_REASONS_REQUESTED'
export const FETCH_INCENTIVE_UPDATE_REASONS_SUCCEEDED = 'FETCH_INCENTIVE_UPDATE_REASONS_SUCCEEDED' 
export const FETCH_INCENTIVE_UPDATE_REASONS_FAILED = 'FETCH_INCENTIVE_UPDATE_REASONS_FAILED'
export const UPDATE_INCENTIVE_REQUESTED = 'UPDATE_INCENTIVE_REQUESTED'
export const UPDATE_INCENTIVE_SUCCEEDED = 'UPDATE_INCENTIVE_SUCCEEDED'
export const UPDATE_INCENTIVE_FAILED = 'UPDATE_INCENTIVE_FAILED'
export const RESET_UPDATE_INCENTIVE_STATE = 'RESET_UPDATE_INCENTIVE_STATE'